// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1eyT6","footer":"ModalUpdate_footer__kGk6L"};